export default __webpack_public_path__ + "static/media/character5.0adc9310.png";